export const FooterElementID = "footer-container";
export const HeaderBottomContainerElementID = "header-bottom-container";
